import React from 'react';
import { SiteNav } from './SiteNav';
import { AccordionItem } from '@moonjellydigital/react-components';
import { MenuItemLink } from './Link';
import { Menu } from 'react-aria-components';

export const SiteHeader = () => {
  return (
    <header className="appshell-header">
      <div className='appshell-header__banner'>
        <p>Voting will open after the Prize for Art submission period ends after November 7th</p>
      </div>
      <div className="appshell-header__row1">
        <a
          className="appshell-header__archive"
          href="https://sheridanprizeforart.com/archives/"
        >
          Sheridan Prize for Art Archives
        </a>
        <Menu style={{ display: 'inline-flex' }}>
          <MenuItemLink
            className={'appshell-header__signUp'}
            to="/register"
            label="Sign Up"
          />
          <MenuItemLink
            className={'appshell-header__signUp'}
            to="/juror-registration"
            label="Juror Sign-up"
          />
          <MenuItemLink
            className={'appshell-header__login'}
            to="/login"
            label="Log In"
          />
        </Menu>
      </div>
      <div className="appshell-header__row2">
        <img
          className="appshell-logo"
          width="182"
          height="72"
          alt="Sheridan Prize for Art"
          src="/sheridan-prize-for-art-logo.png"
        />
        <SiteNav />
        <nav
          aria-label="site"
          className="appshell-siteMenu appshell-siteMenu_large"
        >
          <ul>
            <li>
              <a href="https://www.sheridanprizeforart.com/">Home</a>
            </li>
            <li>
              <a href="https://www.sheridanprizeforart.com/philosophy/">
                Philosophy
              </a>
            </li>
            <li>
              <a href="https://www.sheridanprizeforart.com/donation/">Donate</a>
            </li>
            <li>
              <a href="https://www.sheridanprizeforart.com/contact/">Contact</a>
            </li>
            <li>
              <AccordionItem title="Buy Art Here">
                <ul className="appshell-submenu">
                  <li>
                    <a href="https://sheridanprizeforart.com/shop/">Store</a>
                  </li>
                  <li>
                    <a href="https://sheridanprizeforart.com/cart/">Cart</a>
                  </li>
                  <li>
                    <a href="https://sheridanprizeforart.com/checkout/">
                      Checkout
                    </a>
                  </li>
                </ul>
              </AccordionItem>
            </li>
            <li>
              <a href="https://www.sheridanprizeforart.com/rules/">
                Prize Rules
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};
